module.exports = __webpack_public_path__ + "media/images/v3/Satisfaction2-188fdcecc117cad6281b65d8fe63b71e.png";